import React from 'react';
import { designHomeView as DesignHomeView } from './designHomeView';
import '../../css/login.css';
import APP from '../../modules';

class DesignHomeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errorMessage: '',
      isLoading: false
    };
  }

  onChange = (event) => {
    const { value, name } = event.currentTarget;
    this.setState({ [name]: value });
  };

  componentDidMount() {
    sessionStorage.removeItem('checkId');
  }

  testViewClick = (val) => {
    if (val === 'TestData') {
      sessionStorage.setItem('TestCheck', val);
      this.props.goToPage(APP.Constants.ROUTES.VIEW_REQUIREMENT);
    } else {
      sessionStorage.setItem('TestCheck', val);
      this.props.goToPage(APP.Constants.ROUTES.VIEW_REQUIREMENT);
    }
  };

  render() {
    return (
      <DesignHomeView
        {...{
          ...this.state,
          onChange: this.onChange,
          testViewClick: this.testViewClick
        }}
      />
    );
  }
}

export default DesignHomeComponent;
